function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { string, bool } from 'prop-types';
import SsrScript from '../SsrScript';
/**
 * FontManager component.
 */

var _ref2 = /*#__PURE__*/React.createElement("html", {
  lang: "en",
  className: "wf-active"
});

var FontManager = function FontManager(_ref) {
  var adobeFontsId = _ref.adobeFontsId,
      cssEmbed = _ref.cssEmbed;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      currentId = _useState2[0],
      setCurrentId = _useState2[1]; // Clean up any previous scripts if the ID changes, or on unmount


  useEffect(function () {
    var clean = function clean() {
      _toConsumableArray(document.querySelectorAll('script[src^="https://use.typekit.net"]')).forEach(function (el) {
        el.parentNode.removeChild(el);
      });
    };

    if (currentId) {
      clean();
    }

    setCurrentId(adobeFontsId);
    return function () {
      clean();
    };
  }, [adobeFontsId]);

  if (!adobeFontsId) {
    return null;
  }

  if (cssEmbed) {
    return /*#__PURE__*/React.createElement(Helmet, null, _ref2, /*#__PURE__*/React.createElement("link", {
      rel: "stylesheet",
      href: "https://use.typekit.net/".concat(adobeFontsId, ".css")
    }));
  } // Use the Adobe Fonts JavaScript embed code to load
  // https://helpx.adobe.com/fonts/using/embed-codes.html#JavaScriptembedcode


  return /*#__PURE__*/React.createElement(SsrScript, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("script", null, "\n            (function(d) {\n              var config = {\n                kitId: '".concat(adobeFontsId, "',\n                scriptTimeout: 3000,\n                async: true\n              },\n              h=d.documentElement,t=setTimeout(function(){h.className=h.className.replace(/\bwf-loading\b/g,\"\")+\" wf-inactive\";},config.scriptTimeout),tk=d.createElement(\"script\"),f=false,s=d.getElementsByTagName(\"script\")[0],a;h.className+=\" wf-loading\";tk.src='https://use.typekit.net/'+config.kitId+'.js';tk.async=true;tk.onload=tk.onreadystatechange=function(){a=this.readyState;if(f||a&&a!=\"complete\"&&a!=\"loaded\")return;f=true;clearTimeout(t);try{Typekit.load(config)}catch(e){}};s.parentNode.insertBefore(tk,s)\n            })(document);\n          "))));
};

FontManager.defaultProps = {
  adobeFontsId: null,
  cssEmbed: false
};
FontManager.propTypes = process.env.NODE_ENV !== "production" ? {
  /** An Adobe Fonts ID. */
  adobeFontsId: string,

  /** True if Font Manager should be loaded via css. */
  cssEmbed: bool
} : {};
export default FontManager;